<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
  [title]="titlePage"
  start="{{startStage}}"
  end="{{endStage}}"
></app-ion-common-header>

<ion-content
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <div class="w-title">
    <app-ion-common-label
      [id]="idLabelTaxResidency"
      class="document-type-label1 w-title"
      labelStyle="display-rg"
      labelDescription="Sua residência fiscal é no Brasil?"
      label="Residência fiscal é o país em que você é considerado contribuinte. Você pode ser residente fiscal se tiver cidadania, 
      nacionalidade ou visto permanente (tal como o Green card) de um país ou ainda, se vive, 
      trabalha ou permanece nesse país por um período superior a 183 dias, consecutivos ou não, em um período de até 12 meses."
    >
    </app-ion-common-label>
  </div>

  <div class="control-page text-bold">
    <app-ion-common-button
      [id]="idButtonYes"
      label="Sim"
      typeButton="light"
      positionButton="block"
      (clickButton)="clickNextYes()"
    ></app-ion-common-button>
    <div class="border-top">
      <app-ion-common-button
        [id]="idButtonNo"
        label="Não"
        typeButton="light"
        positionButton="block"
        (clickButton)="clickNextNo()"
      ></app-ion-common-button>
    </div>
  </div>
</ion-content>
